import { render, staticRenderFns } from "./mainDocument.vue?vue&type=template&id=0179d87a&scoped=true&"
import script from "./mainDocument.vue?vue&type=script&lang=js&"
export * from "./mainDocument.vue?vue&type=script&lang=js&"
import style0 from "./mainDocument.vue?vue&type=style&index=0&id=0179d87a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0179d87a",
  null
  
)

export default component.exports